import React from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import './styles/App.scss'
import { persistor, store } from './store'
import moment from 'moment'
import 'moment/locale/ru'
import { ConfigProvider } from 'antd'
import ruRu from 'antd/es/locale/ru_RU'
import { RouterComponent } from '@router/RouterComponent'

moment.locale('ru')

function App() {
  return (
    <div className='App'>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConfigProvider locale={ruRu}>
            <RouterComponent />
          </ConfigProvider>
        </PersistGate>
      </Provider>
    </div>
  )
}

export default App
